module.exports = __webpack_public_path__ + "img/bussinessConfig.ba3af62e.png";